

import { Location } from '@angular/common';
import { Component, Input, Output, OnInit, ViewChild, EventEmitter, ContentChildren, NgModule } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
//shared libs
import { ToastService, ControlsComponent } from '../../../../blocks';
import { NgbModal } from '../../../../ng-bootstrap/index';
import { AppCodeGroup, ControlsParams, SharedModule, OutpatientParms, UserSessionService } from '../../../../shared';
//shared service area
import { TranslateService } from '@ngx-translate/core';
//services
import { Patient } from '../../../../registeration/patients/patient';
import { PatientVisit } from '../../../patient-visit/patient-visit';
import { PatientListComponent } from '../../../../registeration/patients/patient-list.component';
//Block component area
import { LoaderService } from '../../../../ng2-loader/ng2-loader';

import { VisitsHistoryService } from './visits-history.service';
import { ClosePatVisit } from '../../../patient-visit/close-patient-visit/close-patient-visit.component';
import { ReopenPatVisit } from '../../../patient-visit/reopen-patient-visit/reopen-patient-visit.component';
import { CancelPatVisit } from '../../../patient-visit/cancel-patient-visit/cancel-patient-visit.component';
import { ModalContainerModule } from '../../../../blocks/ui-component/modal-container/modal-container.module';
import { PatientVisitsService } from '../../../patient-visit/patient-visit.service';
import { OrderPrintComponent } from '../../../../orders/order-reception/order-print/order-print.component';
@Component({
  selector: 'OutPatReservation-visitsHistory',
  templateUrl: './visits-history.component.html',
  styles: ['']
})
export class VisitsHistoryComponent implements OnInit {
  //Filed area
  @Input() patient: Patient;
  isHistory = true;
  visitsList: any[];
  dynamicComponent: any;
  ynamicComponent: any;
  outpatientParms: OutpatientParms = <OutpatientParms>{};
  totalRecords: number = 0;
  isVisitOption: boolean = false;
  bgColor: any;
  @ViewChild('popup') content: any;
  @Output() private emitUnCompress: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() private emitSelectedVisit: EventEmitter<PatientVisit> = new EventEmitter<PatientVisit>();
  constructor(
    private _visitsHistoryService: VisitsHistoryService,
    private _route: ActivatedRoute,
    public translate: TranslateService,
    private _userSessionService: UserSessionService,
    private _router: Router,
    private _modalService: NgbModal,
    private _location: Location,
    private _toastService: ToastService

  ) {
  }
  ngOnInit() {
  }

  onVisitRowClick(actionCode: number, visit: any) {

    if (actionCode == 2159) {
      this.dynamicComponent = CancelPatVisit;
      this.content.openModal("CancelPatVisit", "VisitsHistory", visit);
    }
    else if (actionCode == 2160) {
      this.dynamicComponent = ClosePatVisit;
      this.content.openModal("ClosePatVisit", "VisitsHistory", visit);
    }
    else if (actionCode == 2161) {
      this.dynamicComponent = ReopenPatVisit;
      this.content.openModal("ReopenPatVisit", "VisitsHistory", visit);
    }
    else if (actionCode == 404) {
      this._userSessionService.setSessionKey('VisitType', visit.visitType);
      this.emitSelectedVisit.emit(visit);
    }
    else if (actionCode == 7254) {
      this.OpenOrderPrint(visit)
    }

  }
  private OpenOrderPrint(visit: any) {
    visit.orderPrintFlag = 1
    this._userSessionService.setSessionKey("OrderDetailPrint", visit);
    this.dynamicComponent = OrderPrintComponent;
    this.content.openModal("OrderPrintComponent", visit);
  }
  toggle() {
    this.isHistory = false;
    this.emitUnCompress.emit(false);

  }
  toggle2(isHistory: boolean) {
    this.isHistory = isHistory;
  }

  getVisitsHistory(_parms: any) {
    this._visitsHistoryService.getVisitsHistory(_parms)
      .subscribe(
        res => {
          if (res['returnFlag']) {
            this.visitsList = res.data ? res.data : [];
            if (res.data.length <= 0 || res.data.filter(s=> s.visitStatus !=3  ).length == 0) {
              this.emitSelectedVisit.emit(_parms);
            }
            this.updatePaginator();
          }
        },
        error => console.log("unable to load visits"),
        () => {
        });
  }
  getPatientVisits(_patCode: number, visitType: number) {
    this.outpatientParms.offset = 0;
    this.outpatientParms.pageSize = 10;
    this.outpatientParms.patCode = _patCode;
    this.outpatientParms.visitType = visitType;
    this.getVisitsHistory(this.outpatientParms);
  }


  updatePaginator() {
    this.totalRecords = (this.visitsList ? (this.visitsList.length > 0 ? this.visitsList[0].rowsCount : 0) : 0);
  }
  paginate(_parms: any) {
    this.outpatientParms.offset = _parms.first;
    this.outpatientParms.pageSize = _parms.rows;
    this.getVisitsHistory(this.outpatientParms);
  }
  //  get class for row in datatable
  getCssClasses = (item, rowIndex: number) => {
    if (item.visitStatus == 3) {
      return 'deleted-row';
    }
  }
  onpopupClose(parms: any) {

    if (parms && parms.output == 'Cross click') {

    }
    else if (parms && parms.output) {
      this.getVisitsHistory(this.outpatientParms);
    }

  }

  reset() {
    this.visitsList = [];
  }

  getAppCodes(allowAddEdit: number): number[] {
    let appcodes = [];
    let component = this._route.routeConfig.component.name;
    if (component == 'EmrDoctorsComponent') {
      appcodes = [404, 7254];
    } else {
      if (allowAddEdit == 1) {
        appcodes = [404, 2159, 2160, 7254];
      } else {
        appcodes = [2159, 2160, 7254];
      }
    }
    return appcodes;
  }
}
@NgModule({
    imports: [SharedModule, RouterModule, ModalContainerModule],
    declarations: [
        VisitsHistoryComponent,
        ClosePatVisit,
        CancelPatVisit,
        ReopenPatVisit,
    ],
    exports: [VisitsHistoryComponent,
        ClosePatVisit,
        CancelPatVisit,
        ReopenPatVisit],
    providers: [VisitsHistoryService, PatientVisitsService]
})
export class VisitsHistoryModule { }
